module.exports = __webpack_public_path__ + "media/images/weather/444_day-e33de8fc5788031938e52319421913bb.png";